module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "index"
  }, [_vm._m(0), _vm._v(" "), _c('mt-swipe', {
    style: ({
      height: _vm.imgHeight + 'px'
    }),
    attrs: {
      "auto": 4000
    }
  }, [_c('mt-swipe-item', [_c('router-link', {
    attrs: {
      "to": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.swiperone($event)
      }
    }
  }, [_c('img', {
    ref: "imgele",
    staticClass: "titleImg",
    attrs: {
      "src": require("../assets/img/home/B-1-min.jpg")
    }
  })])], 1), _vm._v(" "), _c('mt-swipe-item', [_c('router-link', {
    attrs: {
      "to": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.swipertwo($event)
      }
    }
  }, [_c('img', {
    staticClass: "titleImg",
    attrs: {
      "src": require("../assets/img/home/B-2-min.jpg")
    }
  })])], 1), _vm._v(" "), _c('mt-swipe-item', [_c('a', {
    attrs: {
      "href": "http://blog.yunzhitu.com/yunzhitu-case"
    }
  }, [_c('img', {
    staticClass: "titleImg",
    attrs: {
      "src": require("../assets/img/home/B-3-min.jpg")
    }
  })])])], 1), _vm._v(" "), _c('div', {
    staticClass: "recommend"
  }, [_c('router-link', {
    staticClass: "recommendlist",
    attrs: {
      "to": "/expertsrecommend"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/img/index/2.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('p', [_vm._v("专家推荐")])]), _vm._v(" "), _c('router-link', {
    staticClass: "recommendlist",
    attrs: {
      "to": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.goPub($event)
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/img/index/3.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('p', [_vm._v("优质项目")])]), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2)], 1), _vm._v(" "), _c('div', {
    staticClass: "selectbox"
  }, [_c('h1', {
    on: {
      "click": function($event) {
        return _vm.goback()
      }
    }
  }, [_vm._v("为供需双方提供系信息对接平台")]), _vm._v(" "), _c('h6', [_vm._v("一键触达、实时、高效的技术对接解决方案")]), _vm._v(" "), _c('div', {
    staticClass: "select"
  }, [_c('div', {
    staticClass: "send"
  }, [_c('p', {
    staticClass: "need"
  }, [_vm._v("有需求 极速发布")]), _vm._v(" "), _c('p', {
    staticClass: "introdce"
  }, [_vm._v("一键提交用户需求，省时")]), _vm._v(" "), _c('p', {
    staticClass: "introdce"
  }, [_vm._v("专人完善需求资料，省力")]), _vm._v(" "), _c('p', {
    staticClass: "introdce"
  }, [_vm._v("微信实时查询进展，省心")]), _vm._v(" "), _c('div', {
    staticClass: "btns"
  }, [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.sendneed
    }
  }, [_vm._v("我要发需求")])])]), _vm._v(" "), _c('div', {
    staticClass: "send"
  }, [_c('p', {
    staticClass: "need"
  }, [_vm._v("懂技术 便捷接单")]), _vm._v(" "), _c('p', {
    staticClass: "introdce"
  }, [_vm._v("人工验证需求信息，真实有效")]), _vm._v(" "), _c('p', {
    staticClass: "introdce"
  }, [_vm._v("线上直连需求对象，拒绝中介")]), _vm._v(" "), _c('p', {
    staticClass: "introdce"
  }, [_vm._v("真实需求每日更新，实时高效")]), _vm._v(" "), _c('div', {
    staticClass: "btns"
  }, [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.goPub
    }
  }, [_vm._v("我要接需求")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "expertbox"
  }, [_c('h1', [_vm._v("这里都是行业内可信赖的专家")]), _vm._v(" "), _c('h6', [_vm._v("每个专家都经过人工严格审核")]), _vm._v(" "), _c('div', {
    staticClass: "expertlist"
  }, [_c('div', {
    staticClass: "listitem"
  }, [_c('img', {
    attrs: {
      "src": _vm.httpurl + _vm.datalistone.photo,
      "alt": ""
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "name"
  }, [_vm._v("\n                  " + _vm._s(_vm.nickname) + "/" + _vm._s(_vm.datalistone.position) + "\n              ")]), _vm._v(" "), _c('p', {
    staticClass: "info",
    staticStyle: {
      "-webkit-box-orient": "vertical"
    }
  }, [_vm._v(_vm._s(_vm.datalistone.aboutMe))]), _vm._v(" "), _c('div', {
    staticClass: "classifybox"
  }, _vm._l((_vm.dataoneskills), function(item, index) {
    return _c('p', {
      key: index,
      staticClass: "classify"
    }, [_vm._v(_vm._s(item))])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "listitem"
  }, [_c('img', {
    attrs: {
      "src": _vm.httpurl + _vm.datalisttwo.photo,
      "alt": ""
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "name"
  }, [_vm._v("\n                  " + _vm._s(_vm.nicknametwo) + "/" + _vm._s(_vm.datalisttwo.position) + "\n              ")]), _vm._v(" "), _c('p', {
    staticClass: "info",
    staticStyle: {
      "-webkit-box-orient": "vertical"
    }
  }, [_vm._v(_vm._s(_vm.datalisttwo.aboutMe))]), _vm._v(" "), _c('div', {
    staticClass: "classifybox"
  }, _vm._l((_vm.datatwoskills), function(item, index) {
    return _c('p', {
      key: index,
      staticClass: "classify"
    }, [_vm._v(_vm._s(item))])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "listitem"
  }, [_c('img', {
    attrs: {
      "src": _vm.httpurl + _vm.datalistthree.photo,
      "alt": ""
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "name"
  }, [_vm._v("\n                  " + _vm._s(_vm.nicknamethree) + "/" + _vm._s(_vm.datalistthree.position) + "\n              ")]), _vm._v(" "), _c('p', {
    staticClass: "info",
    staticStyle: {
      "-webkit-box-orient": "vertical"
    }
  }, [_vm._v(_vm._s(_vm.datalistthree.aboutMe))]), _vm._v(" "), _c('div', {
    staticClass: "classifybox"
  }, _vm._l((_vm.datathreeskills), function(item, index) {
    return _c('p', {
      key: index,
      staticClass: "classify"
    }, [_vm._v(_vm._s(item))])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "listitem"
  }, [_c('img', {
    attrs: {
      "src": _vm.httpurl + _vm.datalistfour.photo,
      "alt": ""
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "name"
  }, [_vm._v("\n                  " + _vm._s(_vm.nicknamefour) + "/" + _vm._s(_vm.datalistfour.position) + "\n              ")]), _vm._v(" "), _c('p', {
    staticClass: "info",
    staticStyle: {
      "-webkit-box-orient": "vertical"
    }
  }, [_vm._v(_vm._s(_vm.datalistfour.aboutMe))]), _vm._v(" "), _c('div', {
    staticClass: "classifybox"
  }, _vm._l((_vm.datafourskills), function(item, index) {
    return _c('p', {
      key: index,
      staticClass: "classify"
    }, [_vm._v(_vm._s(item))])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "listitem"
  }, [_c('img', {
    attrs: {
      "src": _vm.httpurl + _vm.datalistfive.photo,
      "alt": ""
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "name"
  }, [_vm._v("\n                  " + _vm._s(_vm.nicknamefive) + "/" + _vm._s(_vm.datalistfive.position) + "\n              ")]), _vm._v(" "), _c('p', {
    staticClass: "info",
    staticStyle: {
      "-webkit-box-orient": "vertical"
    }
  }, [_vm._v(_vm._s(_vm.datalistfive.aboutMe))]), _vm._v(" "), _c('div', {
    staticClass: "classifybox"
  }, _vm._l((_vm.datafiveskills), function(item, index) {
    return _c('p', {
      key: index,
      staticClass: "classify"
    }, [_vm._v(_vm._s(item))])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "listitem"
  }, [_c('img', {
    attrs: {
      "src": _vm.httpurl + _vm.datalistsix.photo,
      "alt": ""
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "name"
  }, [_vm._v("\n                  " + _vm._s(_vm.nicknamesix) + "/" + _vm._s(_vm.datalistsix.position) + "\n              ")]), _vm._v(" "), _c('p', {
    staticClass: "info",
    staticStyle: {
      "-webkit-box-orient": "vertical"
    }
  }, [_vm._v(_vm._s(_vm.datalistsix.aboutMe))]), _vm._v(" "), _c('div', {
    staticClass: "classifybox"
  }, _vm._l((_vm.datasixskills), function(item, index) {
    return _c('p', {
      key: index,
      staticClass: "classify"
    }, [_vm._v(_vm._s(item))])
  }), 0)])])]), _vm._v(" "), _c('div', {
    staticClass: "designbox"
  }, [_c('div', {
    staticClass: "pjt_type"
  }, _vm._l((_vm.types), function(types) {
    return _c('span', {
      key: types.id,
      class: {
        selected: _vm.typeSelect == types.name
      },
      on: {
        "click": function($event) {
          return _vm.selected(types)
        }
      }
    }, [_vm._v(_vm._s(types.name))])
  }), 0), _vm._v(" "), _c('van-list', {
    attrs: {
      "finished": _vm.finished,
      "finished-text": "没有更多了"
    },
    on: {
      "load": _vm.onLoad
    },
    model: {
      value: (_vm.loading),
      callback: function($$v) {
        _vm.loading = $$v
      },
      expression: "loading"
    }
  }, [_c('ul', _vm._l((_vm.pjtList), function(pjtList, index) {
    return _c('li', {
      key: index
    }, [_c('div', {
      staticClass: "projectList",
      on: {
        "click": function($event) {
          return _vm.toProjectDetail(pjtList)
        }
      }
    }, [_c('div', {
      staticClass: "leftimg"
    }, [(_vm.typeSelect === '产品设计') ? _c('img', {
      attrs: {
        "src": require("../assets/img/index/chanpin.jpg"),
        "alt": ""
      }
    }) : _vm._e(), _vm._v(" "), (_vm.typeSelect === '机电设计') ? _c('img', {
      attrs: {
        "src": require("../assets/img/index/jidian.jpg"),
        "alt": ""
      }
    }) : _vm._e(), _vm._v(" "), (_vm.typeSelect === '界面设计') ? _c('img', {
      attrs: {
        "src": require("../assets/img/index/jiemian.jpg"),
        "alt": ""
      }
    }) : _vm._e(), _vm._v(" "), (_vm.typeSelect === '程序设计') ? _c('img', {
      attrs: {
        "src": require("../assets/img/index/chengxu.jpg"),
        "alt": ""
      }
    }) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "recommend_Pjt"
    }, [(pjtList.status == 4) ? _c('div', {
      staticClass: "bgimg"
    }, [_vm._v("招募中")]) : _vm._e(), _vm._v(" "), (pjtList.status == 5) ? _c('div', {
      staticClass: "bgimg"
    }, [_vm._v("已关闭")]) : _vm._e(), _vm._v(" "), (pjtList.status == 6) ? _c('div', {
      staticClass: "bgimg"
    }, [_vm._v("已合作")]) : _vm._e(), _vm._v(" "), (pjtList.status == 7) ? _c('div', {
      staticClass: "bgimg"
    }, [_vm._v("进行中")]) : _vm._e(), _vm._v(" "), (pjtList.status == 8) ? _c('div', {
      staticClass: "bgimg"
    }, [_vm._v("已完成")]) : _vm._e(), _vm._v(" "), (pjtList.status == 9) ? _c('div', {
      staticClass: "bgimg"
    }, [_vm._v("已评价")]) : _vm._e()])]), _vm._v(" "), _c('div', {
      staticClass: "rightinfo"
    }, [_c('h1', {
      staticStyle: {
        "-webkit-box-orient": "vertical"
      }
    }, [_vm._v(_vm._s(pjtList.title))]), _vm._v(" "), (pjtList.status == 4) ? _c('p', {
      staticClass: "money"
    }, [_vm._v(_vm._s(pjtList.prePrice))]) : _c('p', {
      staticClass: "money"
    }, [_vm._v(_vm._s(pjtList.charge)), (pjtList.charge) ? _c('span', [_vm._v("元")]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "people"
    }, [_c('span', [_vm._v("推荐" + _vm._s(pjtList.countRecommender) + "人")]), _c('span', [_vm._v("浏览" + _vm._s(pjtList.countVisit) + "人")])])])])])
  }), 0)])], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "logo"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/img/index/1.png")
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "recommendlist",
    attrs: {
      "href": "http://blog.yunzhitu.com/yunzhitu-case/",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/img/index/4.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('p', [_vm._v("经典案例")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "recommendlist",
    attrs: {
      "href": "http://blog.yunzhitu.com/news/",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/img/index/5.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('p', [_vm._v("平台动态")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3e57b35a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/index.vue
// module id = 1274
// module chunks = 1